import { STATUS_COLOR } from "shared/consts";
import { getOpacityColor } from "shared/lib/colors";
import styled from "styled-components";

export const OrderAmountContainer = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  height: 100%;
  gap: 2px;
`;

type OrderAmountBlockProps = {
  $color: string;
  $bg?: string;
}

export const OrderAmountBlock = styled.div<OrderAmountBlockProps>`
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 14px;
  padding: 4px;
  color:${STATUS_COLOR};
  border: 1px solid ${props => props.$color || 'transparent'};
  background-color: ${props => props.$bg || getOpacityColor(props.$color, 0.4)};
  border-radius: calc(1px / 0);
  line-height: 1;
  cursor: default;

  i {
    flex: 0 0 15px;
    width: 15px;
    aspect-ratio: 1;
    display: flex;
    justify-content:center;align-items: center;
  }
`;

export const OrderAmountProviderIcon = styled.div`
  flex: 0 0 21px;
  aspect-ratio: 1;
  display: flex;
  justify-content:center;align-items: center;
`;